/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 04.06.25
 *
 */

import  FundingSourceItem from "@tl/core/modules/commission/model/fundingSources/FundingSourceItem";
import BaseIdObject from "@shared/BaseIdObject";
import {Type} from "@qwoach/class-transformer-wrapper";
import dayjs from "dayjs";

export default class FundingSourcesWrapper extends BaseIdObject {


	clientId: string = null;
	@Type(() => FundingSourceItem)
	fundingSources: FundingSourceItem[] = [];
	localAuthorityId: string = null;

	contractStartDateMs: number = null;
	contractEndDateMs: number = null;

	constructor() {
		super();
	}

	contractDurationMs() {
		if(!this.contractStartDateMs || !this.contractEndDateMs || this.contractEndDateMs < this.contractStartDateMs){
			return 0
		}
		return this.contractEndDateMs - this.contractStartDateMs;
	}
	contractEndsInFormatted() {
		let contractDurationMs = this.contractDurationMs()
		if(contractDurationMs <= 0){
			return ""
		}
			//use dayjs. format to months. if less than a month, show days. If in the past, show "completed on {MM/DD/YYYY}"

		let start = dayjs(this.contractStartDateMs)
		let end = dayjs(this.contractEndDateMs)
		let now = dayjs()
		if(end.isBefore(now)){
			return `Completed on ${end.format("MM/DD/YYYY")}`
		}
		let months = end.diff(start, 'month')
		if(months > 0){
			return `${months} month${months > 1 ? 's' : ''} left`
		}
		let days = end.diff(start, 'day')
		return `${days} day${days > 1 ? 's' : ''} left`
	}

	contractEndDateFormatted() {
		if (!this.contractEndDateMs) {
			return ""
		}
		return dayjs(this.contractEndDateMs).format("MMM DD, YYYY")
	}

	contractStartDateFormatted() {
		if (!this.contractStartDateMs) {
			return ""
		}
		return dayjs(this.contractStartDateMs).format("MMM DD, YYYY")
	}

	getFundingSourceById(fundingSourceId) {
		if (!fundingSourceId) {
			return null;
		}
		return this.fundingSources.find(fundingSource => fundingSource.id === fundingSourceId);
	}

	addFundingSource(fundingSource) {
		if (!(fundingSource instanceof FundingSourceItem)) {
			console.warn("FundingSourcesWrapper: addFundingSource: fundingSource must be an instance of FundingSourceItem");
		}
		return this.fundingSources.push(fundingSource);
	}

	removeFundingSource(fundingSource) {
		if (!(fundingSource instanceof FundingSourceItem)) {
			console.warn("FundingSourcesWrapper: removeFundingSourceById: fundingSource must be an instance of FundingSourceItem");
		}
		return this.fundingSources.deleteItem(fundingSource)
	}

	getFundingSourcesExpanded() {
		return this.fundingSources.map(fundingSource => fundingSource.expand()).flat();
	}
}
